import eventTracker from '@updater-core/interactors/shell/tracker';
import snakeCase from 'lodash/snakeCase';

export type DomainTracker = ReturnType<typeof createDomainTrackerInteractor>;

export function createDomainTrackerInteractor({ domain }) {
  return {
    ...eventTracker,
    selectors: eventTracker.selectors,
    actions: {
      ...eventTracker.actions,
      trackTrack: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.TRACK,
        }),
      trackClick: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.CLICK,
        }),
      trackError: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.ERROR,
        }),
      trackChange: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.CHANGE,
        }),
      trackSubmit: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.SUBMIT,
        }),
      trackUpdate: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.UPDATE,
        }),
      trackDisplay: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.DISPLAY,
        }),
      trackReceive: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.RECEIVE,
        }),
      trackView: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.VIEW,
        }),
      trackPurchase: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.PURCHASE,
        }),
      trackMeasure: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.MEASURE,
        }),
      sendTrigger: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.SENT,
        }),
      trackUpload: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.UPLOAD,
        }),
      trackFail: (object: string, details?: any) =>
        eventTracker.actions.track({
          domain,
          object: snakeCase(object),
          details,
          verb: eventTracker.FAIL,
        }),
    },
  };
}

export default createDomainTrackerInteractor;
